import React from "react";
import DevicesOtherOutlinedIcon from "@mui/icons-material/DevicesOtherOutlined";

// Shown in place of the tiles and charts when the selected store has no
// devices to show.
function NoDevicesBanner() {
  return (
    <div className="dash-empty" role="status">
      <div className="dash-empty-icon">
        <DevicesOtherOutlinedIcon />
      </div>
      <div className="dash-empty-title">No devices found</div>
    </div>
  );
}

export default NoDevicesBanner;
